import script from "./dirct-inqry-register.vue?vue&type=script&setup=true&lang=js"
export * from "./dirct-inqry-register.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__